// Smooth-scroll any link annotated with [data-sb-scroll-to] when its href is a
// hash (or hash-ending URL) pointing to an in-page id. Supports Shopify section
// IDs like "#shopify-section-template--abc__sb_text_with_sidebar" as well as
// custom ids.
(function () {
  function getTarget(href) {
    if (!href) return null;
    var hashIndex = href.indexOf('#');
    if (hashIndex === -1) return null;
    var id = href.slice(hashIndex + 1);
    if (!id) return null;
    return document.getElementById(id) || document.querySelector('[id$="__' + id + '"]');
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-sb-scroll-to]');
    if (!trigger) return;
    var target = getTarget(trigger.getAttribute('href'));
    if (!target) return;
    event.preventDefault();

    // Calculate the top offset; adjust selector as needed for your sticky header.
    var offset = 0;
    var header = document.querySelector('.shopify-section-header, .sticky-header, header.sticky, header.site-header, .header, header'); // Try common names
    if (header) {
      // Use bounding rect in case of non-static position
      offset = header.getBoundingClientRect().height;
    }

    var targetRect = target.getBoundingClientRect();
    var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    var targetTop = targetRect.top + scrollTop - offset;

    window.scrollTo({
      top: targetTop,
      behavior: 'smooth'
    });

    // Move focus for accessibility without scrolling again.
    var prevTabIndex = target.getAttribute('tabindex');
    target.setAttribute('tabindex', '-1');
    target.focus({ preventScroll: true });
    if (prevTabIndex === null) {
      target.removeAttribute('tabindex');
    } else {
      target.setAttribute('tabindex', prevTabIndex);
    }
  });
})();
